import React, { FC } from "react";
import { Oval } from "react-loader-spinner";
import "./SubmitButton.scss";

interface ISubmitButton {
  onClick: (e?: any) => void;
  className: string;
  submitting: boolean;
  disabled?: boolean;
  type?: "button" | "submit";
}

const SubmitButton: FC<ISubmitButton> = (props) => {
  return (
    <button
      onClick={props.onClick}
      className={`${props.className} ${
        props.submitting
          ? "submit-button submit-button--loading"
          : "submit-button"
      }`}
      disabled={props.disabled}
      type={props.type ? props.type : "button"}
    >
      {props.children}
      {props.submitting && (
        <div className="submit-button__loader">
          <Oval
            color="#2bfda7"
            height={24}
            width={24}
            strokeWidth={5}
            secondaryColor="#b6b9be"
          />
        </div>
      )}
    </button>
  );
};

export default SubmitButton;
